<template>
  <div class="index" >
    <van-nav-bar class="head bg-color-theme" title="健康问卷调查" fixed ref="head"  v-if="deviceType !== 'weixin'">
      <template #title>
        <div style="color: #FFFFFF;font-size: 14px;">健康问卷调查</div>
      </template>
    </van-nav-bar>
    <div class="end-main">
      <van-image
          width="100"
          height="100"
          fit="contain"
          :src="require('../assets/end.png')"
      />
      <div style="margin-top:12px">你已经完成本次问卷</div>
      <div>感谢参与!</div>
    </div>
    <div class="bottom">
      <van-button color="#33bdae" round block type="primary" @click="back">
        我知道了
      </van-button>
    </div>

  </div>
</template>

<script>
//import "../utils/jweixin-1.4.0"
//import wx from "weixin-webview-jssdk";
import wx from "weixin-js-sdk";
export default {
  name: "end",
  data() {
    return {
      deviceType: sessionStorage.getItem('deviceType'),
    };
  },
  mounted() {
  },
  methods: {
    back(){
      //console.log("sessionStorage.getItem('deviceType')", sessionStorage.getItem('deviceType'));
      if(sessionStorage.getItem('deviceType') === 'weixin'){
        // 返回到小程序
        wx.miniProgram.switchTab({
          url: '/pages/train/Index'
        })
      } else {
        this.$router.push({
          path: 'login',
          query: {
            area: this.area,
            address: this.address,
          }
        })
      }

    }
  },
}
</script>

<style scoped>
.end-main {
  margin: 33% 20px 0px 20px;
  text-align: center;
}
.bottom {
  margin: 16px;
  position: absolute;
  right: 10px;
  left: 10px;
  bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/user/end.vue